import {Artifact} from "../../../../types";
import {TrackedSearchResults} from "./TrackedSearchResults";
import {EmailDraftRenderer} from "./EmailDraftRenderer";
import {FallbackRenderer} from "./FallbackRenderer";
import {UserAttachmentRenderer} from "./UserAttachmentRenderer";
import {ATTACHMENT_ARTIFACT_TYPE} from "../../utils/pasteAttachments";

interface ArtifactRendererProps {
    artifact: Artifact;
    /** Assistant prose for this message; only the search_results renderer uses it. */
    messageContent?: string;
}

const artifactRenderers: Record<
    string,
    React.ComponentType<{artifact: Artifact; messageContent?: string}>
> = {
    search_results: TrackedSearchResults,
    email_draft: EmailDraftRenderer,
    [ATTACHMENT_ARTIFACT_TYPE]: UserAttachmentRenderer,
};

export function ArtifactRenderer({
    artifact,
    messageContent,
}: ArtifactRendererProps) {
    const Renderer = artifactRenderers[artifact.type];

    if (!Renderer) {
        return (
            <div id={`artifact-${artifact.id}`}>
                <FallbackRenderer artifact={artifact} />
            </div>
        );
    }

    return (
        <div id={`artifact-${artifact.id}`}>
            <Renderer artifact={artifact} messageContent={messageContent} />
        </div>
    );
}
